"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function togglePlay(sourceId, playState) {
  return (0, _utils.actionCreator)(_types.MEDIA_PLAYER_TOGGLE_PLAY, {
    sourceId: sourceId,
    playState: playState
  });
}
var _default = exports["default"] = togglePlay;